import { render, staticRenderFns } from "./FormAdicionalNoturno.vue?vue&type=template&id=49006706"
import script from "./FormAdicionalNoturno.vue?vue&type=script&lang=js"
export * from "./FormAdicionalNoturno.vue?vue&type=script&lang=js"
import style0 from "./FormAdicionalNoturno.vue?vue&type=style&index=0&id=49006706&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports